// Contagem regressiva até `expiresAt` (usada na reserva de unidade e, na
// Task 13, na aba "Unidade" do card do negócio). Atualiza a cada 30s — não
// precisa de segundo a segundo, é só pra não deixar o rótulo velho na tela.
import { computed, onMounted, onUnmounted, ref, unref } from 'vue';

export function useCountdown(expiresAt) {
  const now = ref(Date.now());
  let timer;

  onMounted(() => {
    timer = setInterval(() => {
      now.value = Date.now();
    }, 30000);
  });

  onUnmounted(() => clearInterval(timer));

  const diff = computed(() => new Date(unref(expiresAt)).getTime() - now.value);
  const expired = computed(() => diff.value <= 0);

  const label = computed(() => {
    if (expired.value) return '0min';
    const mins = Math.floor(diff.value / 60000);
    const d = Math.floor(mins / 1440);
    const h = Math.floor((mins % 1440) / 60);
    const m = mins % 60;
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}min`;
    return `${m}min`;
  });

  return { label, expired };
}
